import { create } from 'zustand';

const usePrizePlanStore = create((set) => ({
  modalIsVisible: false,
  setModalVisibility: () =>
    set((state) => ({ modalIsVisible: !state.modalIsVisible })),
}));

export default usePrizePlanStore;
